import {Text, type TextProps} from '@primer/react'
import {clsx} from 'clsx'
import {forwardRef} from 'react'

import {SanitizedHtml} from '../../dom/sanitized-html'
import styles from './text-cell.module.css'

export const TextCell = forwardRef<
  HTMLElement,
  TextProps & {dangerousHtml?: string; isDisabled?: boolean; className?: string}
>(({children, dangerousHtml, className, isDisabled, ...rest}, ref) => {
  if (dangerousHtml) {
    return (
      <SanitizedHtml {...rest} ref={ref} disabled={isDisabled} className={clsx(className, styles.SanitizedHtml)}>
        {dangerousHtml}
      </SanitizedHtml>
    )
  }

  return (
    // @ts-ignore disabled is indeed not supported by 'span', ignoring this error
    <Text {...rest} disabled={isDisabled} ref={ref} className={clsx(className, styles.SanitizedHtml)}>
      {children}
    </Text>
  )
})

TextCell.displayName = 'TextCell'
